/**
 * The letter verification code (spec 12.3): 8 Crockford base32 characters printed on
 * every letter, grouped 4-4 on the sheet ("7K3M-Q2ZP"). People type it from paper, so the
 * normaliser forgives what Crockford forgives: case, the hyphen and spaces, and the
 * look-alikes I and L (both 1) and O (0). U is outside the alphabet and stays invalid.
 * Pure and dependency-free so the public page can import it without the validators.
 * Section 11 adds the derivation from the letter id beside these.
 */

export const KODE_VERIFIKASI_PANJANG = 8
export const KODE_VERIFIKASI_PATTERN = /^[0-9A-HJKMNP-TV-Z]{8}$/

/** Upper case, no separators, look-alikes folded; not yet validated. */
export function normalisasiKodeVerifikasi(input: string): string {
  return input
    .toUpperCase()
    .replace(/[\s-]+/g, '')
    .replace(/[IL]/g, '1')
    .replace(/O/g, '0')
}

export function isKodeVerifikasi(value: string): boolean {
  return KODE_VERIFIKASI_PATTERN.test(value)
}

/** The printed form, two groups of four; anything else is returned as it is. */
export function formatKodeVerifikasi(kode: string): string {
  return kode.length === KODE_VERIFIKASI_PANJANG ? `${kode.slice(0, 4)}-${kode.slice(4)}` : kode
}
